export default __webpack_public_path__ + "static/media/celebrate.507607fd3189ea259c95a5fab7828ced.svg";